module.exports = __webpack_public_path__ + "media/images/icon-button-favorite-active-5ed6308cb7cf269fe6c3d1694dc81e40.svg";